import * as S from "./styled";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
//Components
import LayoutWithList from "../../../LayoutModal/WithList";
import ActionButton from "../../../Button/ActionButton";
import Loading from "../../../Loading";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import { useEffect } from "react";
import useLoading from "../../../../hooks/useLoading";
//Interfaces
import { Inputs } from "Interfaces/ILaboratory";
import { IMaskInput } from "react-imask";
import { ICreate } from "Interfaces/ICreate";
export default function Update({
  isOpenModal: isOpenModalData,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(
        `laboratory/${selectedUrlId}`
      );
      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalData && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalData, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const response = await apiRequest(
        `laboratory/${selectedUrlId}`,
        "PUT",
        data
      );
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalData) {
    return (
      <LayoutWithList
        title="Atualizar Laboratório"
        subTitle="Atualize as informações do laboratório em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.Content>
              <S.Forms>
                <S.FormInput>
                  <S.Label>
                    Laboratório
                    <span>*</span>
                  </S.Label>
                  <S.Input
                    placeholder="Informe o nome do Laboratório"
                    type="text"
                    {...register("laboratory", { required: true })}
                  />
                  {errors.laboratory && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>

                <S.SeparateDiv>
                  <S.FormInput className='inputLeft'>
                    <S.Label>Celular Principal</S.Label>
                    <Controller
                      name="contact"
                      control={control}
                      render={({ field }) => (
                        <IMaskInput
                          className='imask'
                          id="contact"
                          mask="(00)00000-0000"
                          placeholder="(00) 00000-000"
                          {...field}
                        />
                      )}
                    />
                  </S.FormInput>

                  <S.FormInput>
                    <S.Label>
                      E-mail
                    </S.Label>
                    <S.Input
                      placeholder="Informe o e-mail"
                      type="email"
                      {...register("email")}
                    />
                  </S.FormInput>
                </S.SeparateDiv>
              </S.Forms>

              <S.ContentButton>
                <ActionButton
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.Content>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
